import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SelectType from "./SelectType";
import AddCredentialsForm from "./AddCredentialsForm";
import UserDetailsForm from "./UserDetailsForm";
import Box from "@mui/material/Box";

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        S2A Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const steps = ["Select Type", "Add Credintials", "User details"];

function getStepContent(
  step,
  signInData,
  setSignInData,
  handleNext,
  handleBack
) {
  switch (step) {
    case 0:
      return (
        <SelectType
          signInData={signInData}
          setSignInData={setSignInData}
          handleNext={handleNext}
        />
      );
    case 1:
      return (
        <AddCredentialsForm
          signInData={signInData}
          setSignInData={setSignInData}
          handleNext={handleNext}
          handleBack={handleBack}
        />
      );
    case 2:
      return (
        <UserDetailsForm
          signInData={signInData}
          handleNext={handleNext}
          handleBack={handleBack}
          setSignInData={setSignInData}
        />
      );
    default:
      throw new Error("Unknown step");
  }
}

const theme = createTheme();

export default function SignUpSection() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [signInData, setSignInData] = React.useState({
    state: "registered",
    classType: "chemistry",
  });

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container component="main" maxWidth="sm">
        <Paper
          variant="outlined"
          sx={{
            my: { xs: 3, md: 6 },
            p: { xs: 2, md: 3 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            sx={{
              height: "130px",
              width: "250px",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            src="https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2Fphoto_2023-03-28%2017.16.55.jpeg?alt=media&token=a06939a3-722b-4c5c-968d-f58891020238"
            alt="random"
          ></Box>

          <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
            {steps.map((label) => (
              <Step
                key={label}
                // sx={{
                //   "& .MuiStepLabel-root .Mui-completed": {
                //     color: "#FFFF00", // circle color (COMPLETED)
                //   },
                //   "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                //     {
                //       color: "red", // Just text label (COMPLETED)
                //     },
                //   "& .MuiStepLabel-root .Mui-active": {
                //     color: "red", // circle color (ACTIVE)
                //   },
                //   "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel":
                //     {
                //       color: "black", // Just text label (ACTIVE)
                //     },
                //   "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                //     fill: "black", // circle's number (ACTIVE)
                //   },
                // }}
              >
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography variant="h5" gutterBottom>
                Let’s begin our Journey !!!
              </Typography>
              <Typography variant="subtitle1">
                Your account has been created successfully|. Your Class ID is {signInData.classId}
              </Typography>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {getStepContent(
                activeStep,
                signInData,
                setSignInData,
                handleNext,
                handleBack
              )}
            </React.Fragment>
          )}
        </Paper>
        <Copyright />
      </Container>
    </ThemeProvider>
  );
}
